module.exports = __webpack_public_path__ + "img/item_image_10.64f4108a.jpg";